/*
 * Visualiseur InstrumenPoche en Javascript et SVG
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 *
 * Sert à compiler iepjsmax.js et iepjsmin.js, en exportant la version webpack du lecteur iep
 * dans le même espace de nom que précédemment. à savoir une var globale iep
 * (cf webpack.old.config.js avec libraryTarget: var &  library: 'iep')
 * qui s'utilise avec `var app = new iep.iepApp()`
 *
 * On laisse ça, pour ceux qui utilisent encore ces js, dépréciés au profit du loader
 */
const IepApp = require('./app/IepApp')
module.exports = { iepApp: IepApp }
